import { Tabs } from 'antd';
import DefaultModal from '../defaultModal/DefaultModal';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';
import useTranslation from '../../../../hooks/translation/useTranslation';

export default function PasswordRecoveryModal({
  show,
  handleClose,
  activeStep,
  items,
}) {
  const { trans } = useTranslation();
  const { width } = useWindowDimensions();
  return (
    <DefaultModal
      show={width > 1023 && show}
      setShow={handleClose}
      width={630}
    >
      <div className="flex flex-col">
        {activeStep === 1 && (
        <div className="flex justify-between items-center">
          <h1 className="m-0 text-2xl">{trans('password_recovery')}</h1>
        </div>
        )}
        <Tabs className="register-tabs" items={items} activeKey={activeStep} />
      </div>
    </DefaultModal>
  );
}
